import { render, staticRenderFns } from "./Lobby.vue?vue&type=template&id=2efd88db&scoped=true"
import script from "./Lobby.vue?vue&type=script&lang=js"
export * from "./Lobby.vue?vue&type=script&lang=js"
import style0 from "./Lobby.vue?vue&type=style&index=0&id=2efd88db&prod&lang=scss"
import style1 from "./Lobby.vue?vue&type=style&index=1&id=2efd88db&prod&lang=scss&scoped=true"
import style2 from "./Lobby.vue?vue&type=style&index=2&id=2efd88db&prod&lang=css"
import style3 from "./Lobby.vue?vue&type=style&index=3&id=2efd88db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efd88db",
  null
  
)

export default component.exports